<script lang="ts" setup>
	import {Route} from '@/router/route';
	import {computed} from 'vue';
	import {useRoute, useRouter} from 'vue-router';

	const route = useRoute();

	const router = useRouter();

	const isAvailabilityView = computed(() => route.name === Route.AVAILABILITY_OVERVIEW);

	const toggleDetails = () => router.push({name: Route.DETAILS_OVERVIEW});

	const toggleAvailability = () => router.push({name: Route.AVAILABILITY_OVERVIEW});
</script>

<template>
	<div class="catalog-header">
		<div class="catalog-header__inner">
			<div class="catalog-header__breadcrumbs">
				<div class="breadcrumbs">
					<span>{{ $t('site.products.overview.breadcrumb.title') }}</span>
				</div>
			</div>

			<nav class="catalog-header__tabs">
				<button :class="isAvailabilityView ? 'inactive' : 'active'"
				        @click="toggleDetails">
					<span>{{ $t('site.products.overview.tabs.detail.title') }}</span>
				</button>

				<button :class="isAvailabilityView ? 'active' : 'inactive'"
				        @click="toggleAvailability">
					<span>{{ $t('site.products.overview.tabs.availability.title') }}</span>
				</button>
			</nav>
		</div>
	</div>
</template>
